'use strict';

module.exports = require('./es6/crc8').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc8.js
// module id = 646
// module chunks = 0